"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripsAll = exports.tripDone = exports.tripScheduled = exports.tripActive = exports.tripIsAtCurrentLocation = exports.firstScheduledTimestampMsWithDefault = exports.tripFromModernMarket = exports.tripFromPomellaInvoice = exports.tripEarliestScheduledTimestamp = exports.tripState = exports.tripLongName = exports.tripShortName = exports.tripTitleShortest = exports.tripLateFeesAmountC = exports.tripRefundAmountC = exports.tripPricingFormulaInputValues = exports.tripDropOffTimestampMsWithDefault = exports.tripPickupTimestampMsWithDefault = exports.tripLocationsWithDefault = exports.TRIP_LOCATIONS_WITH_DEFAULT_PICKED_PROPERTIES = exports.tripLocationForDescription = exports.tripIsScheduledWithDefault = exports.tripIsEligibleForInstantPayout = exports.tripIsDone = exports.tripIsActive = exports.tripDurationS = exports.tripLocationsDescriptionSimple = exports.tripCurrentLocationWithDefault = exports.tripCompletionTimestampMs = exports.tripActiveLocation = exports.tripIsInstantPayout = exports.tripDeserializeWithoutId = exports.tripDeserialize = void 0;
const currency_js_1 = __importDefault(require("currency.js"));
const find_1 = __importDefault(require("lodash/find"));
const first_1 = __importDefault(require("lodash/first"));
const last_1 = __importDefault(require("lodash/last"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const moment_1 = __importDefault(require("moment"));
const pluralize_1 = __importDefault(require("pluralize"));
const GeocodeController_1 = require("../controllers/google-maps/GeocodeController");
const MomentHelper_1 = require("../helpers/MomentHelper");
const capitalizeFirstOnly_1 = __importDefault(require("../util/capitalizeFirstOnly"));
const exists_1 = __importDefault(require("../util/exists"));
const expect_1 = __importDefault(require("../util/expect"));
const filterBoolean_1 = __importDefault(require("../util/filterBoolean"));
const formatPhone_1 = require("../util/formatPhone");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const BaseUser_1 = require("./BaseUser");
const CancellationReason_1 = require("./CancellationReason");
const Color_1 = require("./Color");
const CoordinatesArray_1 = require("./CoordinatesArray");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const DeviceType_1 = require("./DeviceType");
const DatabaseTimestamp_1 = require("./firebase/DatabaseTimestamp");
const GeocodeResult_1 = require("./google-maps/GeocodeResult");
const Location_1 = require("./Location");
const timestampFromArrayOfTimeStrings_1 = __importDefault(require("./scrapers/timestampFromArrayOfTimeStrings"));
const TripContact_1 = require("./TripContact");
const TripLocation_1 = require("./TripLocation");
const TripSource_1 = require("./TripSource");
const TripStatus_1 = require("./TripStatus");
const TripType_1 = require("./TripType");
function tripDeserialize(value, id) {
    try {
        return Object.assign({ id: (0, deserializeString_1.deserializeString)(id) }, tripDeserializeWithoutId(value));
    }
    catch (error) {
        console.log({ id, value });
        throw error;
    }
}
exports.tripDeserialize = tripDeserialize;
function tripDeserializeWithoutId(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        canceledAt: (0, unwrap_1.default)(object.canceledAt, DatabaseTimestamp_1.databaseTimestampDeserialize),
        cashedOutAt: (0, unwrap_1.default)(object.cashedOutAt, value => (value === -1 ? value : (0, DatabaseTimestamp_1.databaseTimestampDeserialize)(value))),
        cancellationReason: (0, unwrap_1.default)(object.cancellationReason, CancellationReason_1.cancellationReasonDeserialize),
        contacts: (0, unwrap_1.default)(object.contacts, (0, deserializeArray_1.default)(TripContact_1.tripContactDeserialize)),
        createdAt: (0, unwrap_1.default)(object.createdAt, DatabaseTimestamp_1.databaseTimestampDeserialize),
        comments: (0, unwrap_1.default)(object.comments, deserializeString_1.stringDeserialize),
        completedAt: (0, unwrap_1.default)(object.completedAt, DatabaseTimestamp_1.databaseTimestampDeserialize),
        confirmedAt: (0, unwrap_1.default)(object.confirmedAt, DatabaseTimestamp_1.databaseTimestampDeserialize),
        couponCode: (0, unwrap_1.default)(object.couponCode, deserializeString_1.deserializeString),
        currentLocation: (0, unwrap_1.default)(object.currentLocation, deserializeNumber_1.deserializeNumber),
        customer: (0, unwrap_1.default)(object.customer, BaseUser_1.baseUserDeserialize),
        customerId: (0, deserializeString_1.deserializeString)(object.customerId),
        description: (0, unwrap_1.default)(object.description, deserializeString_1.deserializeString),
        deviceType: (0, unwrap_1.default)(object.deviceType, DeviceType_1.deviceTypeDeserialize),
        didOverrideDriverEarnings: (0, unwrap_1.default)(object.didOverrideDriverEarnings, deserializeBoolean_1.default),
        didOverrideEstimate: (0, unwrap_1.default)(object.didOverrideEstimate, deserializeBoolean_1.default),
        directions: (0, unwrap_1.default)(object.directions, deserializeString_1.deserializeString),
        driver: (0, unwrap_1.default)(object.driver, BaseUser_1.baseUserDeserialize),
        driverEarningsD: (0, unwrap_1.default)(object.driverEarningsD, value => (0, deserializeNumber_1.deserializeNumber)(value, 0)),
        driverId: (0, unwrap_1.default)(object.driverId, deserializeString_1.deserializeString),
        dropOffTimestampMs: (0, unwrap_1.default)(object.dropOffTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        estimate: (0, unwrap_1.default)(object.estimate, deserializeNumber_1.deserializeNumber),
        estimatedMiles: (0, unwrap_1.default)(object.estimatedMiles, deserializeNumber_1.deserializeNumber),
        estimatedMinutes: (0, unwrap_1.default)(object.estimatedMinutes, deserializeNumber_1.deserializeNumber),
        estimatedDropOffTimestampMs: (0, unwrap_1.default)(object.estimatedDropOffTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        estimatedPickupTimestampMs: (0, unwrap_1.default)(object.estimatedPickupTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        ezCaterDeliveryId: (0, unwrap_1.default)(object.ezCaterDeliveryId, deserializeString_1.deserializeString),
        ezCaterOrderId: (0, unwrap_1.default)(object.ezCaterOrderId, deserializeString_1.deserializeString),
        firstColor: (0, unwrap_1.default)(object.firstColor, Color_1.colorDeserialize),
        firstScheduledTimestampMs: (0, unwrap_1.default)(object.firstScheduledTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        fromAddress: (0, unwrap_1.default)(object.fromAddress, deserializeString_1.deserializeString),
        fromCoordinate: (0, unwrap_1.default)(object.fromCoordinate, CoordinatesArray_1.coordinatesArrayDeserialize),
        fromPlaceId: (0, unwrap_1.default)(object.fromPlaceId, deserializeString_1.deserializeString),
        fromPlaceName: (0, unwrap_1.default)(object.fromPlaceName, deserializeString_1.deserializeString),
        hasSentNearbyNotification: (0, unwrap_1.default)(object.hasSentNearbyNotification, deserializeBoolean_1.default),
        isScheduled: (0, unwrap_1.default)(object.isScheduled, deserializeBoolean_1.default),
        isTest: (0, unwrap_1.default)(object.isTest, deserializeBoolean_1.default),
        locations: (0, unwrap_1.default)(object.locations, (0, deserializeArray_1.default)(TripLocation_1.tripLocationDeserialize, true)),
        orderId: (0, unwrap_1.default)(object.orderId, deserializeString_1.deserializeString),
        orderValue: (0, unwrap_1.default)(object.orderValue, deserializeNumber_1.deserializeNumber),
        paymentIntentId: (0, unwrap_1.default)(object.paymentIntentId, deserializeString_1.deserializeString),
        pickupWaitTimeS: (0, unwrap_1.default)(object.pickupWaitTimeS, deserializeNumber_1.deserializeNumber),
        quoteId: (0, unwrap_1.default)(object.quoteId, deserializeString_1.deserializeString),
        requestedDropOffTimestampMs: (0, unwrap_1.default)(object.requestedDropOffTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        requestedPickupTimestampMs: (0, unwrap_1.default)(object.requestedPickupTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        requiresResponse: (0, unwrap_1.default)(object.requiresResponse, deserializeBoolean_1.default),
        riderFeedbackTimestampMs: (0, unwrap_1.default)(object.riderFeedbackTimestampMs, DatabaseTimestamp_1.databaseTimestampDeserialize),
        secondColor: (0, unwrap_1.default)(object.secondColor, Color_1.colorDeserialize),
        scheduleTimestamp: (0, unwrap_1.default)(object.scheduleTimestamp, DatabaseTimestamp_1.databaseTimestampDeserialize),
        source: (0, unwrap_1.default)(object.source, TripSource_1.tripSourceDeserialize),
        startedAt: (0, unwrap_1.default)(object.startedAt, DatabaseTimestamp_1.databaseTimestampDeserialize),
        status: (0, TripStatus_1.tripStatusDeserialize)(object.status),
        tip: (0, unwrap_1.default)(object.tip, deserializeNumber_1.deserializeNumber),
        toAddress: (0, unwrap_1.default)(object.toAddress, deserializeString_1.deserializeString),
        toCoordinate: (0, unwrap_1.default)(object.toCoordinate, CoordinatesArray_1.coordinatesArrayDeserialize),
        toPlaceId: (0, unwrap_1.default)(object.toPlaceId, deserializeString_1.deserializeString),
        toPlaceName: (0, unwrap_1.default)(object.toPlaceName, deserializeString_1.deserializeString),
        twilioProxySessionId: (0, unwrap_1.default)(object.twilioProxySessionId, deserializeString_1.deserializeString),
        type: (0, TripType_1.tripTypeDeserialize)(object.type),
        vendorId: (0, unwrap_1.default)(object.vendorId, deserializeString_1.deserializeString),
        vendorName: (0, unwrap_1.default)(object.vendorName, deserializeString_1.deserializeString),
    };
}
exports.tripDeserializeWithoutId = tripDeserializeWithoutId;
// ------------------------------------------------------------------------------------------------------------ //
function tripIsInstantPayout(trip) {
    return TripType_1.tripTypeRideshare.includes(trip.type);
}
exports.tripIsInstantPayout = tripIsInstantPayout;
// active location
/**
 * The first location without a completion timestamp
 */
function tripActiveLocation(trip) {
    const locations = tripLocationsWithDefault(trip);
    if (locations) {
        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];
            if (!location.completionTimestampMs) {
                return [i, location];
            }
        }
    }
    return undefined;
}
exports.tripActiveLocation = tripActiveLocation;
// completion timestamp
function tripCompletionTimestampMs(trip) {
    var _a, _b, _c;
    const number = (_c = (_b = (_a = (0, find_1.default)(trip.locations, location => Boolean(location.completionTimestampMs))) === null || _a === void 0 ? void 0 : _a.completionTimestampMs) !== null && _b !== void 0 ? _b : trip.completedAt) !== null && _c !== void 0 ? _c : trip.canceledAt;
    return typeof number === 'number' ? number : undefined;
}
exports.tripCompletionTimestampMs = tripCompletionTimestampMs;
// current location (with default)
/**
 * The index of the active location
 * @returns Returns zero,
 */
function tripCurrentLocationWithDefault(trip) {
    const locations = tripLocationsWithDefault(trip);
    for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        if (!location.completionTimestampMs) {
            return i;
        }
    }
    return undefined;
}
exports.tripCurrentLocationWithDefault = tripCurrentLocationWithDefault;
// description
function locationDescriptionShortened(location) {
    return (0, Location_1.locationDescriptionSimple)(location).replace(/, .. \d\d\d\d\d, USA/, '');
}
function tripLocationsDescriptionSimple(trip) {
    const locations = tripLocationsWithDefault(trip);
    if (locations.length === 1) {
        return locationDescriptionShortened(locations[0]);
    }
    else {
        let string = `${locationDescriptionShortened((0, expect_1.default)((0, first_1.default)(locations)))} to ${locationDescriptionShortened((0, expect_1.default)((0, last_1.default)(locations)))}`;
        if (locations.length > 2) {
            const stopCount = locations.length - 2;
            string += `, ${stopCount} ${(0, pluralize_1.default)('stop', stopCount)}`;
        }
        return string;
    }
}
exports.tripLocationsDescriptionSimple = tripLocationsDescriptionSimple;
// duration (from pickup to drop-off)
function tripDurationS(trip) {
    const locations = tripLocationsWithDefault(trip);
    return (0, unwrap_1.default)((0, first_1.default)(locations), pickup => (0, unwrap_1.default)((0, last_1.default)(locations), dropOff => {
        var _a, _b;
        return (0, unwrap_1.default)((_b = (_a = pickup.arrivalTimestampMs) !== null && _a !== void 0 ? _a : pickup.completionTimestampMs) !== null && _b !== void 0 ? _b : pickup.estimatedArrivalTimestampMs, pickupTimestamp => {
            var _a, _b;
            return (0, unwrap_1.default)((_b = (_a = dropOff.arrivalTimestampMs) !== null && _a !== void 0 ? _a : dropOff.completionTimestampMs) !== null && _b !== void 0 ? _b : dropOff.estimatedArrivalTimestampMs, dropOffTimestamp => (dropOffTimestamp - pickupTimestamp) / 1000);
        });
    }));
}
exports.tripDurationS = tripDurationS;
// is active
function tripIsActive(trip) {
    return TripStatus_1.tripStatusActive.includes(trip.status);
}
exports.tripIsActive = tripIsActive;
// is done
function tripIsDone(trip) {
    return TripStatus_1.tripStatusDone.includes(trip.status);
}
exports.tripIsDone = tripIsDone;
// is eligible for instant payout
function tripIsEligibleForInstantPayout(trip, driverId) {
    return (trip.driverId === driverId &&
        trip.cashedOutAt == -1 &&
        !!trip.driverEarningsD &&
        trip.driverEarningsD > 0 &&
        trip.status === 'COMPLETED');
}
exports.tripIsEligibleForInstantPayout = tripIsEligibleForInstantPayout;
// is scheduled (with default)
function tripIsScheduledWithDefault(trip) {
    var _a;
    return (_a = trip.isScheduled) !== null && _a !== void 0 ? _a : Boolean((0, find_1.default)(tripLocationsWithDefault(trip), trip => Boolean(trip.scheduledTimestampMs)));
}
exports.tripIsScheduledWithDefault = tripIsScheduledWithDefault;
// location for description
function tripLocationForDescription(trip) {
    const locations = tripLocationsWithDefault(trip);
    switch (trip.type) {
        case 'delivery':
        case 'runner':
            return (0, first_1.default)(locations);
        default:
            return (0, last_1.default)(locations);
    }
}
exports.tripLocationForDescription = tripLocationForDescription;
// locations (with default)
exports.TRIP_LOCATIONS_WITH_DEFAULT_PICKED_PROPERTIES = [
    'locations',
    'scheduleTimestamp',
    'startedAt',
    'requestedPickupTimestampMs',
    'estimatedPickupTimestampMs',
    'pickupWaitTimeS',
    'dropOffTimestampMs',
    'completedAt',
    'requestedDropOffTimestampMs',
    'estimatedDropOffTimestampMs',
    'fromAddress',
    'fromCoordinate',
    'fromPlaceId',
    'fromPlaceName',
    'description',
    'toAddress',
    'toCoordinate',
    'toPlaceId',
    'toPlaceName',
];
function tripLocationsWithDefault(trip) {
    var _a, _b;
    if (trip.locations) {
        const locations = [...trip.locations];
        const pickup = (0, first_1.default)(locations);
        if (pickup) {
            (0, unwrap_1.default)(trip.scheduleTimestamp, t => (pickup.scheduledTimestampMs = t));
            (0, unwrap_1.default)(trip.startedAt, t => (pickup.completionTimestampMs = t));
            (0, unwrap_1.default)(trip.requestedPickupTimestampMs, t => (pickup.requestedTimestampMs = t));
            (0, unwrap_1.default)(trip.estimatedPickupTimestampMs, t => (pickup.estimatedArrivalTimestampMs = t));
            (0, unwrap_1.default)(trip.pickupWaitTimeS, t => (pickup.waitTimeS = t));
        }
        if (locations.length > 1) {
            const dropOff = (0, last_1.default)(locations);
            (0, unwrap_1.default)(trip.dropOffTimestampMs, t => (dropOff.scheduledTimestampMs = t));
            (0, unwrap_1.default)(trip.completedAt, t => (dropOff.completionTimestampMs = t));
            (0, unwrap_1.default)(trip.requestedDropOffTimestampMs, t => (dropOff.requestedTimestampMs = t));
            (0, unwrap_1.default)(trip.estimatedDropOffTimestampMs, t => (dropOff.estimatedArrivalTimestampMs = t));
        }
        return locations;
    }
    else {
        const locations = [
            {
                address: trip.fromAddress,
                coordinates: (_a = trip.fromCoordinate) !== null && _a !== void 0 ? _a : [0, 0],
                googlePlaceId: trip.fromPlaceId,
                name: trip.fromPlaceName,
                contactUserType: 'CUSTOMER',
                instructions: trip.description,
                contents: undefined,
                waitTimeS: trip.pickupWaitTimeS,
                scheduledTimestampMs: trip.scheduleTimestamp,
                completionTimestampMs: trip.startedAt,
                requestedTimestampMs: trip.requestedPickupTimestampMs,
                estimatedArrivalTimestampMs: trip.estimatedPickupTimestampMs,
            },
        ];
        if (trip.fromCoordinate !== trip.toCoordinate) {
            locations.push({
                address: trip.toAddress,
                coordinates: (_b = trip.toCoordinate) !== null && _b !== void 0 ? _b : [0, 0],
                googlePlaceId: trip.toPlaceId,
                name: trip.toPlaceName,
                contactUserType: undefined,
                instructions: undefined,
                contents: undefined,
                waitTimeS: undefined,
                scheduledTimestampMs: trip.dropOffTimestampMs,
                completionTimestampMs: trip.completedAt,
                requestedTimestampMs: trip.requestedDropOffTimestampMs,
                estimatedArrivalTimestampMs: trip.estimatedDropOffTimestampMs,
            });
        }
        return locations;
    }
}
exports.tripLocationsWithDefault = tripLocationsWithDefault;
// pickup timestamp ms with default
function tripPickupTimestampMsWithDefault(trip) {
    var _a, _b;
    return (_a = trip.scheduleTimestamp) !== null && _a !== void 0 ? _a : (_b = (0, first_1.default)(trip.locations)) === null || _b === void 0 ? void 0 : _b.scheduledTimestampMs;
}
exports.tripPickupTimestampMsWithDefault = tripPickupTimestampMsWithDefault;
// drop-off timestamp ms with default
function tripDropOffTimestampMsWithDefault(trip) {
    var _a, _b;
    return (_a = trip.dropOffTimestampMs) !== null && _a !== void 0 ? _a : (_b = (0, last_1.default)(trip.locations)) === null || _b === void 0 ? void 0 : _b.scheduledTimestampMs;
}
exports.tripDropOffTimestampMsWithDefault = tripDropOffTimestampMsWithDefault;
// pricing formula input values
function tripPricingFormulaInputValues(trip) {
    var _a, _b, _c, _d, _e, _f;
    const locations = tripLocationsWithDefault(trip);
    const waitTimes = (0, reduce_1.default)(locations, (total, location) => { var _a; return total + ((_a = location.waitTimeS) !== null && _a !== void 0 ? _a : 0); }, 0);
    return {
        charge: (_a = trip.orderValue) !== null && _a !== void 0 ? _a : 0,
        miles: (_b = trip.estimatedMiles) !== null && _b !== void 0 ? _b : 0,
        minutes: ((_c = trip.estimatedMinutes) !== null && _c !== void 0 ? _c : 0) + waitTimes,
        tip: (_d = trip.tip) !== null && _d !== void 0 ? _d : 0,
        revenue: ((_e = trip.estimate) !== null && _e !== void 0 ? _e : 0) + ((_f = trip.tip) !== null && _f !== void 0 ? _f : 0),
    };
}
exports.tripPricingFormulaInputValues = tripPricingFormulaInputValues;
// refund amount in cents
function tripRefundAmountC(amountRefundableC, trip) {
    let amountC = amountRefundableC;
    // apply late fees
    amountC -= tripLateFeesAmountC(trip);
    // double check
    if (amountC < 0) {
        return 0;
    }
    return amountC;
}
exports.tripRefundAmountC = tripRefundAmountC;
// late fees amount in cents
function tripLateFeesAmountC(trip) {
    let amountC = 0;
    const minutes = trip.confirmedAt ? (moment_1.default.now() - trip.confirmedAt) * 60000 : 0;
    // apply late fee
    if (TripType_1.tripTypePremium.includes(trip.type)) {
        if (minutes >= 5) {
            amountC += 1000;
        }
    }
    else {
        if (minutes >= 2) {
            amountC += 500;
        }
    }
    // apply extra-late fee
    if (TripType_1.tripTypePremium.includes(trip.type)) {
        if (minutes >= 20) {
            amountC += 1000;
        }
    }
    else {
        if (minutes >= 10) {
            amountC += 500;
        }
    }
    return amountC;
}
exports.tripLateFeesAmountC = tripLateFeesAmountC;
// shortest title
function tripTitleShortest(trip) {
    var _a, _b;
    return (_b = (_a = trip.orderId) !== null && _a !== void 0 ? _a : trip.ezCaterOrderId) !== null && _b !== void 0 ? _b : (0, TripType_1.tripTypeTitle)(trip.type);
}
exports.tripTitleShortest = tripTitleShortest;
// short name
function tripShortName(trip) {
    if (trip.orderId) {
        if (trip.source) {
            return `${(0, TripSource_1.tripSourceDescription)(trip.source)} ${trip.orderId}`;
        }
        else {
            return trip.orderId;
        }
    }
    else if (trip.ezCaterOrderId) {
        return `ezCater ${`#${trip.ezCaterOrderId.substring(0, 3)}-${trip.ezCaterOrderId.substring(3, 3)}`}`;
    }
    else {
        return (0, capitalizeFirstOnly_1.default)((tripIsScheduledWithDefault(trip) ? 'Scheduled ' : '') + (0, TripType_1.tripTypeTitle)(trip.type));
    }
}
exports.tripShortName = tripShortName;
// long name
function tripLongName(trip) {
    return [
        tripShortName(trip),
        (0, unwrap_1.default)(tripEarliestScheduledTimestamp(trip), ts => `(scheduled ${(0, MomentHelper_1.momentFormatTimeOrDate)((0, moment_1.default)(ts))})`, () => (trip.createdAt ? `(created ${(0, MomentHelper_1.momentFormatTimeOrDate)((0, moment_1.default)(trip.createdAt))})` : '')),
    ].join(' ');
}
exports.tripLongName = tripLongName;
async function tripState(trip, googleApiOptions) {
    var _a, _b, _c;
    const locations = tripLocationsWithDefault(trip);
    return ((_b = (_a = locations.find(location => location.state)) === null || _a === void 0 ? void 0 : _a.state) !== null && _b !== void 0 ? _b : (0, unwrap_1.default)((_c = (await (0, GeocodeController_1.reverseGeocode)(locations[0].coordinates, googleApiOptions)).results[0]) === null || _c === void 0 ? void 0 : _c.address_components, GeocodeResult_1.geocodeResultState));
}
exports.tripState = tripState;
function tripEarliestScheduledTimestamp(trip) {
    var _a;
    return (_a = tripLocationsWithDefault(trip).find(location => Boolean(location.scheduledTimestampMs))) === null || _a === void 0 ? void 0 : _a.scheduledTimestampMs;
}
exports.tripEarliestScheduledTimestamp = tripEarliestScheduledTimestamp;
async function tripFromPomellaInvoice(invoice, googleMapsOptions) {
    // geocode pickup
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const pickupResults = await (0, unwrap_1.default)((_a = invoice.pickupDetails) === null || _a === void 0 ? void 0 : _a.address, address => (0, GeocodeController_1.geocode)(address, googleMapsOptions));
    const pickupResult = (0, first_1.default)(pickupResults === null || pickupResults === void 0 ? void 0 : pickupResults.results);
    const pickup = (_b = (await (0, unwrap_1.default)(pickupResult, result => (0, TripLocation_1.tripLocationFromGeocodeResult)(result, undefined, googleMapsOptions)))) !== null && _b !== void 0 ? _b : {};
    // pickup time
    pickup.scheduledTimestampMs = (0, moment_1.default)((0, expect_1.default)((_c = invoice.orderDetails) === null || _c === void 0 ? void 0 : _c.orderDate, 'order date') +
        ' ' +
        (0, expect_1.default)((_d = invoice.pickupDetails) === null || _d === void 0 ? void 0 : _d.dayAndTime, 'picku day and time')).valueOf();
    // pickup instructions
    pickup.instructions = (0, filterBoolean_1.default)([
        (_f = (_e = invoice.pickupDetails) === null || _e === void 0 ? void 0 : _e.pickupInstructions) === null || _f === void 0 ? void 0 : _f.map(instr => instr === null || instr === void 0 ? void 0 : instr.trim()).filter(Boolean).join('\n'),
        (_h = (_g = invoice.paymentDetails) === null || _g === void 0 ? void 0 : _g.notes) === null || _h === void 0 ? void 0 : _h.trim(),
    ]).join('\n');
    // pickup contents / sub-contents
    if ((_j = invoice.orderSummary) === null || _j === void 0 ? void 0 : _j.length) {
        const contents = [];
        for (const summary of invoice.orderSummary) {
            contents.push({
                title: (0, filterBoolean_1.default)([
                    summary.name,
                    (0, unwrap_1.default)(summary.noOfPeople, number => `for ${number}`),
                    (0, unwrap_1.default)(summary.addOn, addOn => `(${addOn})`),
                ]).join(' '),
                quantity: (0, unwrap_1.default)((_k = summary.Qty) === null || _k === void 0 ? void 0 : _k.trim(), Number),
            });
            if ((_l = summary.catering) === null || _l === void 0 ? void 0 : _l.length) {
                for (const catering of summary.catering) {
                    contents.push({
                        title: `(${catering})`,
                        quantity: 0,
                    });
                }
            }
        }
        if (contents.length) {
            pickup.contents = contents;
        }
    }
    // compile results
    return {
        locations: [pickup],
        type: 'delivery',
        status: 'SCHEDULED',
        orderId: (_m = invoice.orderDetails) === null || _m === void 0 ? void 0 : _m.orderNo,
        tip: (0, unwrap_1.default)((_p = (_o = invoice.paymentDetails) === null || _o === void 0 ? void 0 : _o.tip) === null || _p === void 0 ? void 0 : _p.trim(), string => (0, currency_js_1.default)(string).value),
    };
}
exports.tripFromPomellaInvoice = tripFromPomellaInvoice;
async function tripFromModernMarket(invoice, googleMapsOptions) {
    // order id
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    const storeCode = (_b = (_a = invoice.orderDetails) === null || _a === void 0 ? void 0 : _a.storeCode) === null || _b === void 0 ? void 0 : _b.trim();
    const invoiceNumber = (_d = (_c = invoice.orderDetails) === null || _c === void 0 ? void 0 : _c.invoiceNo) === null || _d === void 0 ? void 0 : _d.trim();
    const orderId = storeCode && invoiceNumber ? `${storeCode} - ${invoiceNumber}` : undefined;
    // geocode pickup
    const pickupResults = await (0, unwrap_1.default)((_e = invoice.orderDetails) === null || _e === void 0 ? void 0 : _e.store, address => (0, GeocodeController_1.geocode)(`Lemonade, ${address}`, googleMapsOptions));
    const pickupResult = (0, first_1.default)(pickupResults === null || pickupResults === void 0 ? void 0 : pickupResults.results);
    const pickup = (_f = (await (0, unwrap_1.default)(pickupResult, result => (0, TripLocation_1.tripLocationFromGeocodeResult)(result, undefined, googleMapsOptions)))) !== null && _f !== void 0 ? _f : {};
    // other pickup details
    pickup.contactUserType = 'RESTAURANT';
    pickup.contents = (_g = invoice.foodDetails) === null || _g === void 0 ? void 0 : _g.map(detail => {
        var _a, _b;
        return ({
            title: ((_a = detail.title) === null || _a === void 0 ? void 0 : _a.trim()) || undefined,
            quantity: Number((_b = detail.quantity) === null || _b === void 0 ? void 0 : _b.trim) || undefined,
        });
    });
    // geocode drop-off
    const dropOffResults = await (0, unwrap_1.default)((_h = invoice.deliveryInfo) === null || _h === void 0 ? void 0 : _h.address, address => (0, GeocodeController_1.geocode)(address, googleMapsOptions));
    const dropOffResult = (0, first_1.default)(dropOffResults === null || dropOffResults === void 0 ? void 0 : dropOffResults.results);
    const dropOff = (_j = (await (0, unwrap_1.default)(dropOffResult, result => (0, TripLocation_1.tripLocationFromGeocodeResult)(result, undefined, googleMapsOptions)))) !== null && _j !== void 0 ? _j : {};
    // other drop-off properties
    const deliveryDate = (_l = (_k = invoice.deliveryInfo) === null || _k === void 0 ? void 0 : _k.date) === null || _l === void 0 ? void 0 : _l.trim();
    dropOff.scheduledTimestampMs =
        deliveryDate && ((_m = invoice.deliveryInfo) === null || _m === void 0 ? void 0 : _m.time)
            ? (0, timestampFromArrayOfTimeStrings_1.default)((_o = invoice.deliveryInfo) === null || _o === void 0 ? void 0 : _o.time, deliveryDate)
            : undefined;
    dropOff.name = (_p = invoice.deliveryInfo) === null || _p === void 0 ? void 0 : _p.name;
    dropOff.instructions = (0, filterBoolean_1.default)([
        (_s = (_r = (_q = invoice.otherDetails) === null || _q === void 0 ? void 0 : _q.orderNote) === null || _r === void 0 ? void 0 : _r.deliveryInstructions) === null || _s === void 0 ? void 0 : _s.trim(),
        ((_u = (_t = invoice.deliveryInfo) === null || _t === void 0 ? void 0 : _t.noOfGuests) === null || _u === void 0 ? void 0 : _u.trim())
            ? `Number of guests: ${(_w = (_v = invoice.deliveryInfo) === null || _v === void 0 ? void 0 : _v.noOfGuests) === null || _w === void 0 ? void 0 : _w.trim()}`
            : undefined,
    ]).join('\n\n');
    dropOff.contactUserType = 'ORDERER';
    // drop-off contact
    const contacts = [];
    contacts.push({
        name: (_x = invoice.deliveryInfo) === null || _x === void 0 ? void 0 : _x.name,
        phone: ((_y = invoice.deliveryInfo) === null || _y === void 0 ? void 0 : _y.phone) ? (0, formatPhone_1.formatPhoneE164)(invoice.deliveryInfo.phone) : undefined,
        userType: 'ORDERER',
    });
    // estimate
    const subTotal = (_0 = (_z = invoice.paymentDetails) === null || _z === void 0 ? void 0 : _z.subTotal) === null || _0 === void 0 ? void 0 : _0.trim();
    const estimate = subTotal ? (0, currency_js_1.default)(subTotal).value : undefined;
    // trip
    const gratuity = (_2 = (_1 = invoice.paymentDetails) === null || _1 === void 0 ? void 0 : _1.gratuity) === null || _2 === void 0 ? void 0 : _2.trim();
    const tip = gratuity ? (0, currency_js_1.default)(gratuity).value : undefined;
    // return trip
    return {
        deviceType: 'WEB',
        estimate,
        locations: [pickup, dropOff],
        orderId,
        source: 'DISPATCH_PORTAL',
        status: 'SCHEDULED',
        tip,
        type: 'delivery',
    };
}
exports.tripFromModernMarket = tripFromModernMarket;
function firstScheduledTimestampMsWithDefault(trip) {
    var _a, _b, _c, _d, _e;
    return ((_c = (_b = (_a = trip.firstScheduledTimestampMs) !== null && _a !== void 0 ? _a : trip.scheduleTimestamp) !== null && _b !== void 0 ? _b : trip.dropOffTimestampMs) !== null && _c !== void 0 ? _c : (_e = (_d = trip.locations) === null || _d === void 0 ? void 0 : _d.find(location => location.scheduledTimestampMs)) === null || _e === void 0 ? void 0 : _e.scheduledTimestampMs);
}
exports.firstScheduledTimestampMsWithDefault = firstScheduledTimestampMsWithDefault;
function tripIsAtCurrentLocation(trip) {
    const currentLocation = tripCurrentLocationWithDefault(trip);
    const locations = tripLocationsWithDefault(trip);
    return (0, exists_1.default)(currentLocation) && (0, exists_1.default)(locations[currentLocation].arrivalTimestampMs);
}
exports.tripIsAtCurrentLocation = tripIsAtCurrentLocation;
// ------------------------------------------------------------------------------------------------------------ //
// dummy data
async function tripActive() {
    return Object.entries(exports.tripsAll)
        .filter(([_id, trip]) => TripStatus_1.tripStatusActive.includes(trip.status))
        .map(([id, trip]) => Object.assign(trip, { id }));
}
exports.tripActive = tripActive;
async function tripScheduled() {
    return Object.entries(exports.tripsAll)
        .filter(([_id, trip]) => 'SCHEDULED'.includes(trip.status))
        .map(([id, trip]) => Object.assign(trip, { id }));
}
exports.tripScheduled = tripScheduled;
async function tripDone() {
    return Object.entries(exports.tripsAll)
        .filter(([_id, trip]) => TripStatus_1.tripStatusDone.includes(trip.status))
        .map(([id, trip]) => Object.assign(trip, { id }));
}
exports.tripDone = tripDone;
exports.tripsAll = {
    '0': {
        id: '0',
        createdAt: Date.now(),
        customer: { firstName: 'Tim', lastName: 'Hawkins', phone: '+17047062272' },
        customerId: 'VW5t6Xl9hoW4rxREHWx86wuoiou2',
        driverId: 'VW5t6Xl9hoW4rxREHWx86wuoiou2',
        driver: { firstName: 'Driver', lastName: 'Example', phone: '+17047062272' },
        locations: [TripLocation_1.dummyWithAddress, TripLocation_1.dummyWithName],
        status: 'CREATED',
        type: 'scoopXl',
    },
    // '1': new Trip('1', 'SCHEDULED', 'scoopXl', [dummyWithAddress, dummyWithName]),
    // '2': new Trip('2', 'SCHEDULED', 'scoopXl', [dummyWithAddress, dummyWithName]),
    // '4': new Trip('3', 'ACCEPTED', 'scoopXl', [dummyWithAddress, dummyWithName]),
    // '5': new Trip('4', 'STARTED', 'scoopXl', [dummyWithAddress, dummyWithName]),
    // '6': new Trip('5', 'STARTED', 'delivery', [dummyWithNameDelivery, dummyWithAddress]),
    // '7': new Trip('6', 'COMPLETED', 'scoopM', [dummyWithAddress, dummyWithName]),
    // '8': new Trip('7', 'CANCELED-BY-RIDER', 'delivery', [dummyWithNameDelivery, dummyWithAddress]),
    // '9': new Trip('8', 'CANCELED-BY-DRIVER', 'delivery', [dummyWithNameDelivery, dummyWithAddress]),
};
